import "./style.less";
// eslint-disable-next-line no-unused-vars
import calenderWeeks from "./assets/icon-weeks.svg";
// eslint-disable-next-line no-unused-vars
import calenderWeek from "./assets/icon-week.svg";
// eslint-disable-next-line no-unused-vars
import calenderDay from "./assets/icon-day.svg";

export default function SearchViewMode(UrlFactory, localStorageService) {
    return {
        restrict: "E",
        scope: {
            mode: "@",
            activity: "<",
            location: "<",
            search: "=",
            showAlreadyReserved: "=",
            callback: "=",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.goToPeriodsFixed = function (search) {
                UrlFactory.setRoute(
                    search.activity,
                    search.location,
                    search.date,
                    search.start,
                    search.end,
                    search.hours,
                    4 //weeks default
                );
            };

            /**
             * interface with localStorageService
             */

            const storageKey = "showAlreadyReservedPeriods";

            const StorageFacade = {
                get: () => {
                    return JSON.parse(localStorageService.get(storageKey));
                },

                set: (storageObj) => {
                    localStorageService.set(storageKey, storageObj);
                },

                removeAll: () => {
                    localStorageService.remove(storageKey);
                },
            };

            $scope.showAlreadyReserved =
                StorageFacade.get() !== null ? StorageFacade.get() : false;

            $scope.showAlreadyReservedStringModel =
                $scope.showAlreadyReserved.toString();

            $scope.$watch("showAlreadyReservedStringModel", function (bool) {
                if (typeof bool === "string") {
                    bool = bool === "true" ? true : false;
                }

                StorageFacade.set(bool);

                $scope.showAlreadyReserved = bool;
            });
        },
    };
}
